const doc = [({"da":({"js":({"nemoa":({"layout":({"top_menu":({"user_menu_item":({"index":({"account":"Konto", "sign_out":"Log ud"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;